import { mdiIdCard } from '@mdi/js'
import Icon from '@mdi/react'

const IdCard = (props) => (
    <Icon data-testid="Icon__IdCard" path={mdiIdCard} size={1} {...props} />
)

export default IdCard
